export const DEFAULT_PAGINATION = { pageIndex: 0, pageSize: 10 };
export const DEFAULT_SORTING = [];
